var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { initComponentInstanceIndexMap, clearHocMap } from '@tencent/gems-shared';
import { parseSchema } from '@tencent/gems-renderer-core';
import { AppRender } from './AppRender';
import { RenderStoreProvider, useRenderStore } from './store';
import { OptionContext } from './OptionContext';
export * from '@tencent/gems-renderer-core';
export * from './IteratorContext';
// For debug
window.stores = [];
var RenderApp = function () {
    var _a = useContext(OptionContext), schema = _a.schema, renderInstance = _a.renderInstance, materials = _a.materials, autoParseStyle = _a.autoParseStyle;
    var renderStore = useRenderStore();
    // For debug
    useEffect(function () {
        window.stores.push(renderStore);
        return function () {
            window.stores = window.stores.filter(function (store) { return store !== renderStore; }) || [];
        };
    }, [renderStore]);
    var schemaInstance = useMemo(function () {
        if (schema) {
            return parseSchema(schema, materials, {
                autoParseStyle: autoParseStyle,
                renderStore: renderStore,
            });
        }
        return {
            componentInstances: [],
            pluginInstances: [],
        };
    }, [schema, materials, autoParseStyle, renderStore]);
    useEffect(function () {
        return function () {
            clearHocMap();
        };
    }, []);
    var _b = renderInstance !== null && renderInstance !== void 0 ? renderInstance : schemaInstance, componentInstances = _b.componentInstances, pluginInstances = _b.pluginInstances;
    initComponentInstanceIndexMap(componentInstances);
    return React.createElement(AppRender, { pluginInstances: pluginInstances, componentInstances: componentInstances });
};
var Renderer = function (_a) {
    var _b = _a.rendererHooks, rendererHooks = _b === void 0 ? {} : _b, externalStore = _a.externalStore, _c = _a.meta, meta = _c === void 0 ? {} : _c, _d = _a.global, global = _d === void 0 ? {} : _d, _e = _a.autoParseStyle, autoParseStyle = _e === void 0 ? true : _e, _f = _a.parseExpression, parseExpression = _f === void 0 ? true : _f, restProps = __rest(_a, ["rendererHooks", "externalStore", "meta", "global", "autoParseStyle", "parseExpression"]);
    var constructHook = rendererHooks.construct, didMountHook = rendererHooks.didMount;
    useState(function () {
        constructHook === null || constructHook === void 0 ? void 0 : constructHook();
    });
    useEffect(function () {
        didMountHook === null || didMountHook === void 0 ? void 0 : didMountHook();
    }, []);
    return (React.createElement(RenderStoreProvider, { renderStore: externalStore },
        React.createElement(OptionContext.Provider, { value: __assign({ meta: meta, global: global, autoParseStyle: autoParseStyle, parseExpression: parseExpression }, restProps) },
            React.createElement(RenderApp, null))));
};
export default Renderer;
//# sourceMappingURL=index.js.map